import api from '../api/client';

/**
 * Sends a non-blocking UI audit log to the backend.
 * @param {Object} options
 * @param {'VIEW_LIST'|'OPEN_FORM'|'EXPORT'|'SEARCH'|'FILTER'|'CREATE'|'UPDATE'|'DELETE'} options.actionType
 * @param {string} options.module - e.g. 'Utilizatori', 'Orase/Sate', 'Doctori', etc.
 * @param {string} [options.entityType] - e.g. 'user', 'city', 'doctor'
 * @param {string|number} [options.entityId] - ID of the entity being viewed/edited
 * @param {string} [options.entityName] - Display name or identifier of the entity
 * @param {string} [options.description] - Human readable summary of the event
 * @param {string} [options.routePath] - Current route or pathname (defaults to window.location.pathname)
 * @param {Object|any} [options.details] - Additional contextual details
 */
export async function logAuditUI({
  actionType,
  module,
  entityType = null,
  entityId = null,
  entityName = null,
  description = null,
  routePath = null,
  details = null,
}) {
  try {
    const currentPath = routePath || (typeof window !== 'undefined' ? window.location.pathname : '');
    await api.post('/api/audit/log-ui-event', {
      actionType,
      module,
      entityType,
      entityId: entityId != null ? String(entityId) : null,
      entityName,
      description,
      routePath: currentPath,
      details,
    });
  } catch (err) {
    // Non-blocking UI log
    console.debug('UI Audit Log failed:', err?.message || err);
  }
}

export default logAuditUI;
